import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, DecimalPipe, UpperCasePipe, LowerCasePipe } from '@angular/common';

@Pipe({
    name: 'dynamicFormatter'
})
export class DynamicPipe implements PipeTransform {
    constructor(
        private datePipe: DatePipe,
        private decimalPipe: DecimalPipe,
        private upperCasePipe: UpperCasePipe,
        private lowerCasePipe: LowerCasePipe
    ) {}

    transform(value: any, pipeType: string): any {
        switch (pipeType) {
            case 'date':
                return this.datePipe.transform(value, 'mediumDate');
            case 'number':
                return this.decimalPipe.transform(value, '1.0-2');
            case 'currency':
                return this.decimalPipe.transform(value, '1.2-2');
            case 'uppercase':
                return this.upperCasePipe.transform(value);
            case 'lowercase':
                return this.lowerCasePipe.transform(value);
            case 'boolean':
                return this.booleanFormatter(value);
            default:
                return value;
        }
    }

    booleanFormatter(value: any): any {
        return value === true ? 'Yes' : 'No';
    }
}
